<div class="row wrapper border-bottom white-bg page-heading info-projeto">
  <div class="col-lg-10 title-projeto">
    <h2>QR Obras</h2>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content box-content-layout">
          <div class="info-page">
            <h3>{{ actionLabel }} Obra</h3>
          </div>

          <div class="alert alert-info" *ngIf="entity?.readonly">
            <h5>Info: </h5>
            <ul>
              <li>Você não tem autorização para editar</li>
            </ul>
          </div>

          <form [formGroup]="form">
            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Nome da obra <sup class="text-danger">*</sup></label>
                <input id="title" class="form-control" formControlName="title" placeholder="Nome da obra" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Descrição da obra</label>
                <textarea id="description" class="form-control" rows="4" formControlName="description" placeholder="Descrição da obra" maxlength="512"></textarea>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Investimento <sup class="text-danger">*</sup></label>
                <input type="text" id="global_value" class="form-control text-end" formControlName="global_value" placeholder="Investimento" maxlength="14" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" autocomplete="off">
                <app-field-message [field]="fieldMessageRequired('global_value')" [erros]="fieldErros('global_value')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Órgão <sup class="text-danger">*</sup></label>
                <ng-select id="agency_id" class="ng-select-alternative" [items]="list?.agencyList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="agency_id">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('agency_id')" [erros]="fieldErros('agency_id')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b" *ngIf="entity?.project_full_id || infoProjeto?.project_full_id">
              <div class=" col-sm-8">
                <label class="col-sm-12 pb-1">Projeto</label>
                <input id="project_full_title" class="form-control" formControlName="project_full_title">
              </div>
            </div>

            <div class="form-group row m-b" *ngIf="entity?.pf_prt_issue_id || infoProjeto?.pf_prt_issue_id">
              <div class=" col-sm-8">
                <label class="col-sm-12 pb-1">Entrega</label>
                <input id="pf_prt_issue_title" class="form-control" formControlName="pf_prt_issue_title">
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Responsável titular</label>
                <ng-select id="manager" class="ng-select-alternative" [items]="list?.personList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="manager">
                </ng-select>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Responsável adjunto</label>
                <ng-select id="adjunct" class="ng-select-alternative" [multiple]="true" [items]="list?.personList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="adjunct">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('adjunct')" [erros]="fieldErros('adjunct')"></app-field-message>
              </div>
            </div>

            <label class="col-sm-12 pb-1">Município da obra <sup class="text-danger">*</sup></label>
            <div formArrayName="work_city">
              <div class="form-group row m-b" *ngFor="let item of getFormArray('work_city').controls; let i = index">
                <div class="col-10 col-md-8 col-xl-4">
                  <ng-select class="ng-select-alternative" [items]="list?.cityList" bindLabel="label" bindValue="id" placeholder="Selecione o Município" [formControlName]="i">
                  </ng-select>
                  <app-field-message [field]="fieldMessageRequireds2('work_city', i)" [erros]="fieldErrosFormArray2('work_city', i)"></app-field-message>
                </div>
                <button class="btn btn-danger col-1 btn-remove" type="button" (click)="removeField(i, 'work_city')">
                  <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
                </button>
              </div>
            </div>
            <button class="btn btn-success btn-add-item mb-4" type="button" (click)="addField('work_city')">Novo Município</button>

            <label class="col-sm-12 pb-1">Município atendidos</label>
            <div formArrayName="work_city_ben">
              <div class="form-group row m-b" *ngFor="let item of getFormArray('work_city_ben').controls; let i = index">
                <div class="col-10 col-md-8 col-xl-4">
                  <ng-select class="ng-select-alternative" [items]="list?.cityList" bindLabel="label" bindValue="id" placeholder="Selecione o Município" [formControlName]="i">
                  </ng-select>
                </div>
                <button class="btn btn-danger col-1 btn-remove" type="button" (click)="removeField(i, 'work_city_ben')">
                  <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
                </button>
              </div>
            </div>
            <button class="btn btn-success btn-add-item mb-4" type="button" (click)="addField('work_city_ben')">Novo Município</button>

            <!-- Table -->
            <div class="form-group row m-b">
              <div class="col-12 col-sm-8">
                <label class="col-sm-12 pb-1">Local da obra:</label>
                <div class="system-table table-container system-table-m-b table-form">
                  <div class="system-table-conteiner system-table-form-conteiner system-table-select">
                    <table>
                      <thead>
                        <tr>
                          <th>Latitude</th>
                          <th>Longitude</th>
                          <th class="text-center btn-icon-td">Ações</th>
                        </tr>
                      </thead>
                      <tbody formArrayName="work_latlng">
                        <tr *ngFor="let item of getFormArray('work_latlng').controls; let i = index" [formGroupName]="i">
                          <td class="title">
                            <input type="text" class="form-control" formControlName="lat">
                            <app-field-message [field]="fieldMessageRequireds('work_latlng', 'lat', i)" [erros]="fieldErrosFormArray('work_latlng', 'lat', i)"></app-field-message>
                          </td>
                          <td>
                            <input type="text" class="form-control" formControlName="lng">
                            <app-field-message [field]="fieldMessageRequireds('work_latlng','lng', i)" [erros]="fieldErrosFormArray('work_latlng', 'lng', i)"></app-field-message>
                          </td>
                          <td>
                            <div class="btn-icon">
                              <span class="icon-table icon-red" (click)="removeField(i, 'work_latlng')">
                                <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
                              </span>
                            </div>
                          </td>
                        </tr>
                        <tr *ngIf="!getFormArray('work_latlng').controls.length" class="border-b-radius">
                          <td colspan="5" class="text-center">Nenhuma Localização Cadastrada</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <button class="btn btn-success btn-add-question mb-0" type="button" (click)="addLagLng()">Nova Localização</button>
                </div>
              </div>
            </div>

            <h4 class="mt-4 mb-3">Mapa Governo</h4>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Tag mapa</label>
                <ng-select id="map_gov_id" class="ng-select-alternative" [items]="list?.mapGov" bindLabel="name" bindValue="id" placeholder="Selecione" formControlName="map_gov_id">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('map_gov_id')" [erros]="fieldErros('map_gov_id')"></app-field-message>
              </div>
            </div>

            <h4 class="mt-4 mb-3">Info placa</h4>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Identificação da obra no órgão
                  <i class="pl-1 fa fa-info-circle icon" tooltip="A identificação deve ser única para cada um dos registros incluídos pelo órgão." placement="bottom"></i>
                </label>
                <input id="code" class="form-control" formControlName="code" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('code')" [erros]="fieldErros('code')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Empresa executora Razão Social <sup class="text-danger">*</sup></label>
                <input id="name_exec" class="form-control" formControlName="name_exec" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('name_exec')" [erros]="fieldErros('name_exec')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Empresa executora CNPJ</label>
                <input id="doc_exec" class="form-control" formControlName="doc_exec" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('doc_exec')" [erros]="fieldErros('doc_exec')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Responsável Técnico Nome <sup class="text-danger">*</sup></label>
                <input id="name_resp" class="form-control" formControlName="name_resp" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('name_resp')" [erros]="fieldErros('name_resp')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Responsável Técnico Nº do registro CREA/CAU <sup class="text-danger">*</sup></label>
                <input id="register_resp" class="form-control" formControlName="register_resp" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('register_resp')" [erros]="fieldErros('register_resp')"></app-field-message>
              </div>
            </div>
            
            <div class="form-group row m-b" *ngIf="countResponsavel > 1">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Responsável Técnico Nome 2</label>
                <input id="name_resp_2" class="form-control" formControlName="name_resp_2" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('name_resp_2')" [erros]="fieldErros('name_resp_2')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b" *ngIf="countResponsavel > 1">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Responsável Técnico Nº do registro CREA/CAU 2</label>
                <input id="register_resp_2" class="form-control" formControlName="register_resp_2" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('register_resp_2')" [erros]="fieldErros('register_resp_2')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b" *ngIf="countResponsavel > 2">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Responsável Técnico Nome 3</label>
                <input id="name_resp_3" class="form-control" formControlName="name_resp_3" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('name_resp_3')" [erros]="fieldErros('name_resp_3')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b" *ngIf="countResponsavel > 2">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Responsável Técnico Nº do registro CREA/CAU 3</label>
                <input id="register_resp_3" class="form-control" formControlName="register_resp_3" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('register_resp_3')" [erros]="fieldErros('register_resp_3')"></app-field-message>
              </div>
            </div>
            <button *ngIf="countResponsavel < 3" class="btn btn-success btn-add-item mb-4" type="button" (click)="addResponsavel()">Novo Responsável</button>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Fiscal Técnico Nome</label>
                <input id="name_supervisor" class="form-control" formControlName="name_supervisor" maxlength="255">
                <app-field-message [field]="fieldMessageRequired('name_supervisor')" [erros]="fieldErros('name_supervisor')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Fiscal Técnico Nº do registro CREA/CAU</label>
                <input id="register_supervisor" class="form-control" formControlName="register_supervisor" maxlength="16">
                <app-field-message [field]="fieldMessageRequired('register_supervisor')" [erros]="fieldErros('register_supervisor')"></app-field-message>
              </div>
            </div>

            <h4 class="mt-4 mb-3">Situação da obra</h4>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Status do serviço <sup class="text-danger">*</sup></label>
                <ng-select id="status_id" class="ng-select-alternative" [items]="list?.statusList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="status_id">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('status_id')" [erros]="fieldErros('status_id')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Data de início</label>
                <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_ini_goal" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'dt_ini_goal')">
                <app-field-message [field]="fieldMessageRequired('dt_ini_goal')" [erros]="fieldErros('dt_ini_goal')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Data de término</label>
                <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_ini_done" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'dt_ini_done')">
                <app-field-message [field]="fieldMessageRequired('dt_ini_done')" [erros]="fieldErros('dt_ini_done')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Data de paralisação</label>
                <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_paralyzed" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'dt_paralyzed')">
                <app-field-message [field]="fieldMessageRequired('dt_paralyzed')" [erros]="fieldErros('dt_paralyzed')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Motivo de paralisação</label>
                <textarea id="ds_paralyzed" class="form-control" rows="4" formControlName="ds_paralyzed" placeholder="Descrição do Motivo" maxlength="512"></textarea>
                <app-field-message [field]="fieldMessageRequired('ds_paralyzed')" [erros]="fieldErros('ds_paralyzed')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class=" col-sm-8 col-xl-4">
                <label class="col-sm-12 pb-1">Percentual de Execução</label>
                <input id="perc_exec" class="form-control text-end" formControlName="perc_exec" maxlength="5" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',', precision: 0}" autocomplete="off">
                <app-field-message [field]="fieldMessageRequired('perc_exec')" [erros]="fieldErros('perc_exec')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Etapa atual da obra</label>
                <textarea id="situation" class="form-control" rows="4" formControlName="situation" placeholder="Etapa da obra" maxlength="512"></textarea>
                <app-field-message [field]="fieldMessageRequired('situation')" [erros]="fieldErros('situation')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b" *ngIf="entity?.id">
              <div class="col-12 col-sm-8">
                <label class="col-sm-12 pb-1">Local da obra:</label>
                <div class="col-12 row p-0 qr-code-img">
                  <qrcode #qr [qrdata]="qrCodeLink" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
                  <div class="col-sm-4">
                    <button class="btn btn-white" (click)="downloadQrCode()" title="QR Code" download target="_blank">Download</button>
                    <a class="btn btn-white" href="//{{ qrCodeLink }}" title="QR Code" target="_blank">Acesse</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-danger m-r-xxl" *ngIf="entity?.id && entity?.can_delete" (click)="confirmExcluir()" type="button">Excluir</button>
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button class="btn btn-primary" type="button" (click)="salvar()" *ngIf="canSave">Salvar</button>
              </div>
            </div>
          </form>

          <app-historico-atualizacoes-list *ngIf="entity?.id" [audit]="audit"></app-historico-atualizacoes-list>

          <div class="container_component" *ngIf="this.entity?.id">
            <div class="hr-line-dashed"></div>
            <app-documento-obras-list [idObra]="this.entity?.id"></app-documento-obras-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>